module.exports = __webpack_public_path__ + "img/gongshui-2.830002a2.png";